// advertising.jsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  Typography,
  Select,
  MenuItem,
  TextField,
  Button,
  CardContent,
  CircularProgress,
} from "@mui/material";

import { Chart } from "react-google-charts";

import config from '../twh/config';

const BASE_URL = config.reactApi_baseUrl + '/react-api/data-insights/advertising-data';

// 🔥 APIs
const api_googleAds     = BASE_URL + "/GA4-googleAds.php";
const api_metaAds       = BASE_URL + "/GA4-metaAds.php";
const api_tiktokAds     = BASE_URL + "/GA4-tiktokAds.php";

const api_facebookMeta  = BASE_URL + "/FB-meta-scoreCards.php";
const api_fb_table      = BASE_URL + "/FB-meta-table-mensenBereikt.php";

const api_pie_platform  = BASE_URL + "/FB-meta-piechart-bereik-platform.php";
const api_fb_insta      = BASE_URL + "/FB-meta-table-facebook-instagram.php";
const api_campaign      = BASE_URL + "/FB-meta-table-performanceCampagne.php";
const api_adset         = BASE_URL + "/FB-meta-table-performanceAdSet.php";


export default function Advertising() {
  const [dateRange, setDateRange] = useState("1 Week");
  const [customMode, setCustomMode] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  /* API 1 - Google Ads */
  const [googleAds, setGoogleAds] = useState({views: 0, percentage: "N/A",});


  const [google_loading, setGoogleLoading] = useState(false);


  const fetchData_googleAds = async (range) => {
    try {
      setGoogleLoading(true);

      const res = await fetch(api_googleAds, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          dateRange: range,
        }),
      });

      const json = await res.json();
      console.log(json);
      setGoogleAds({
        views: json?.purchase?.views || 0,
        percentage: json?.purchase
          ? json.purchase.percentage + "%"
          : "N/A",
      });
    } catch (err) {
      console.error(err);
    } finally {
      setGoogleLoading(false);
    }
  };


  /* API 2 - Meta Ads */
  const [metaAds, setMetaAds] = useState({views: 0, percentage: "N/A",});


  const [meta_loading, setMetaLoading] = useState(false);

  const fetchData_metaAds = async (range) => {
    try {
      setMetaLoading(true);

      const res = await fetch(api_metaAds, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          dateRange: range,
        }),
      });

      const json = await res.json();

      setMetaAds({
        views: json?.purchase?.views || 0,
        percentage: json?.purchase ? json.purchase.percentage + "%" : "N/A",
      });


    } catch (err) {
      console.error(err);
    } finally {
      setMetaLoading(false);
    }
  };



  /* API 3 - TikTok Ads */
  const [tiktokAds, setTiktokAds] = useState({views: 0, percentage: "N/A",});

  const [tiktok_loading, setTiktokLoading] = useState(false);

  const fetchData_tiktokAds = async (range) => {
    try {
      setTiktokLoading(true);

      const res = await fetch(api_tiktokAds, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          dateRange: range,
        }),
      });

      const json = await res.json();

      setTiktokAds({
        views: json?.purchase?.views || 0,
        percentage: json?.purchase ? json.purchase.percentage + "%" : "N/A",
      });

    } catch (err) {
      console.error(err);
    } finally {
      setTiktokLoading(false);
    }
  };


  // google ads api
  const data = [
    ["Year", "Clicks", "Clicks (Previous 28 Days)"],
    ["2004", 1000, 400],
    ["2005", 1170, 460],
    ["2006", 660, 1120],
    ["2007", 1030, 540],
  ];

  const options = {
    title: "",
    curveType: "function",
    legend: { position: "top" },
  };












  


  /* API 4 FACEBOOK */
  const [reach, setReach] = useState({ views: 0, percentage: "N/A" });
  const [spend, setSpend] = useState({ views: 0, percentage: "N/A" });
  const [impressions, setImpressions] = useState({ views: 0, percentage: "N/A" });
  const [cpm, setCpm] = useState({ views: 0, percentage: "N/A" });
  const [reservations, setReservations] = useState({ views: 0, percentage: "N/A" });

  const [metaScore_loading, setMetaScoreLoading] = useState(false);

  const fetchData_facebookMeta = async (range) => {
  try {
    setMetaScoreLoading(true);

    const res = await fetch(api_facebookMeta, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        dateRange: range,
      }),
    });

    const json = await res.json();

    // reach
    setReach({
      views: json?.reach?.views || 0,
      percentage: json?.reach ? json.reach.percentage + "%" : "N/A",
    });

    // spend
    setSpend({
      views: json?.spend?.views || 0,
      percentage: json?.spend ? json.spend.percentage + "%" : "N/A",
    });

    // impressions
    setImpressions({
      views: json?.impressions?.views || 0,
      percentage: json?.impressions ? json.impressions.percentage + "%" : "N/A",
    });

    // cpm
    setCpm({
      views: json?.cpm?.views || 0,
      percentage: json?.cpm ? json.cpm.percentage + "%" : "N/A",
    });

    // reservations (agar API me ho)
    setReservations({
      views: json?.reservations?.views || 0,
      percentage: json?.reservations ? json.reservations.percentage + "%" : "N/A",
    });

  } catch (err) {
    console.error(err);
  } finally {
    setMetaScoreLoading(false);
  }
};




  /* API 5 FACEBOOK */

  const [fbTable, setFBTable] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);

  const fetchData_tableMensenBereikt = async (range) => {
    try {
      setLoadingTable(true);

      const res = await fetch(api_fb_table, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({ dateRange: range }),
      });

      const json = await res.json();

      setFBTable(json?.response?.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingTable(false);
    }
  };

   /* =========================
     PIE CHART (PLATFORM)
  ==========================*/
  const [pieData, setPieData] = useState([]);
  const [loadingPie, setLoadingPie] = useState(false);

  const fetchPie = async (range) => {
    try {
      setLoadingPie(true);

      const res = await fetch(api_pie_platform, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ dateRange: range }),
      });

      const json = await res.json();
      setPieData(json || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingPie(false);
    }
  };

  /* =========================
     FACEBOOK / INSTAGRAM TABLE
  ==========================*/
  const [fbInsta, setFbInsta] = useState({});
  const [loadingFbInsta, setLoadingFbInsta] = useState(false);

  const fetchFbInsta = async (range) => {
    try {
      setLoadingFbInsta(true);

      const res = await fetch(api_fb_insta, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ dateRange: range }),
      });

      const json = await res.json();
      setFbInsta(json || {});
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingFbInsta(false);
    }
  };

  /* =========================
     CAMPAIGN TABLE
  ==========================*/
  const [campaigns, setCampaigns] = useState([]);
  const [loadingCampaign, setLoadingCampaign] = useState(false);

  const fetchCampaign = async (range) => {
    try {
      setLoadingCampaign(true);

      const res = await fetch(api_campaign, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ dateRange: range }),
      });

      const json = await res.json();
      setCampaigns(json?.response?.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingCampaign(false);
    }
  };

  /* =========================
     ADSET TABLE
  ==========================*/
  const [adsets, setAdsets] = useState([]);
  const [loadingAdset, setLoadingAdset] = useState(false);

  const fetchAdset = async (range) => {
    try {
      setLoadingAdset(true);

      const res = await fetch(api_adset, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ dateRange: range }),
      });

      const json = await res.json();
      setAdsets(json?.response?.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingAdset(false);
    }
  };


















  // dropdown change
  const handleChange = (value) => {
    setDateRange(value);

    if (value === "custom") {
      setCustomMode(true);
    } else {
      setCustomMode(false);

      fetchData_googleAds(value);
      fetchData_metaAds(value);
      fetchData_tiktokAds(value);
      
      fetchData_facebookMeta(value);
      fetchData_tableMensenBereikt(value);

      fetchPie(value);
      fetchFbInsta(value);
      fetchCampaign(value);
      fetchAdset(value);
    }
  };

  // custom submit
  const handleCustomSubmit = () => {
    if (!startDate || !endDate) return;

    const range = `${startDate}====${endDate}`;

    fetchData_googleAds(range);
    fetchData_metaAds(range);
    fetchData_tiktokAds(range);

    fetchData_facebookMeta(range);
    fetchData_tableMensenBereikt(range);

    fetchPie(range);
    fetchFbInsta(range);
    fetchCampaign(range);
    fetchAdset(range);
  };

  useEffect(() => {
    fetchData_googleAds(dateRange);
    fetchData_metaAds(dateRange);
    fetchData_tiktokAds(dateRange);

    fetchData_facebookMeta(dateRange);
    fetchData_tableMensenBereikt(dateRange);

    fetchPie(dateRange);
    fetchFbInsta(dateRange);
    fetchCampaign(dateRange);
    fetchAdset(dateRange);
  }, []);




  return (
    <Box>
      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Typography variant="h4" fontWeight={800}>
          ADVERTISING
        </Typography>

        <Select
          size="small"
          value={dateRange}
          onChange={(e) => handleChange(e.target.value)}
        >
          <MenuItem value="3 Days">3 Days</MenuItem>
          <MenuItem value="1 Week">1 Week</MenuItem>
          <MenuItem value="1 Month">1 Month</MenuItem>
          <MenuItem value="6 Months">6 Months</MenuItem>
          <MenuItem value="1 Year">1 Year</MenuItem>
          <MenuItem value="custom">Custom</MenuItem>
        </Select>
      </Box>

      {/* CUSTOM DATE */}
      {customMode && (
        <Box display="flex" gap={2} mb={3}>
          <TextField
            type="date"
            label="Start Date"
            size="small"
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setStartDate(e.target.value)}
          />

          <TextField
            type="date"
            label="End Date"
            size="small"
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setEndDate(e.target.value)}
          />

          <Button variant="contained" onClick={handleCustomSubmit}>
            Get
          </Button>
        </Box>
      )}

      {/* SECTION */}
      <Typography variant="h6" fontWeight={800} gutterBottom>
        Reserveringen
      </Typography>

      <Grid container spacing={2}>
        {/* Google Ads */}
        <Grid item size={{md:4}} sx={{mb:2}}>
          <Card sx={{ px: 3, py: 2, textAlign: "center", position: "relative" }}>
            {google_loading && (
              <CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />
            )}

            <Typography variant="h4" sx={{ fontWeight: "bold", color: "#0718AB" }}>
              {googleAds.views}
            </Typography>

            <Typography sx={{ fontSize: "12px" }}>
              Google Ads
            </Typography>

            <Typography sx={{ fontSize: "12px", color: googleAds.percentage === "N/A" ? "red" : "green" }}>
              {googleAds.percentage}
            </Typography>
          </Card>
        </Grid>

        {/* Meta Ads */}
        <Grid item size={{md:4}} sx={{mb:2}}>
          <Card sx={{ px: 3, py: 2, textAlign: "center", position: "relative" }}>
            {meta_loading && (
              <CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />
            )}

            <Typography variant="h4" sx={{ fontWeight: "bold", color: "#0718AB" }}>
              {metaAds.views}
            </Typography>

            <Typography sx={{ fontSize: "12px" }}>
              META Ads
            </Typography>

            <Typography sx={{ fontSize: "12px", color: metaAds.percentage === "N/A" ? "red" : "green" }}>
              {metaAds.percentage}
            </Typography>
          </Card>
        </Grid>

        {/* TikTok Ads */}
        <Grid item size={{md:4}} sx={{mb:2}}>
          <Card sx={{ px: 3, py: 2, textAlign: "center", position: "relative" }}>
            {tiktok_loading && (
              <CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />
            )}

            <Typography variant="h4" sx={{ fontWeight: "bold", color: "#0718AB" }}>
              {tiktokAds.views}
            </Typography>

            <Typography sx={{ fontSize: "12px" }}>
              TikTok Ads
            </Typography>

            <Typography sx={{ fontSize: "12px", color: tiktokAds.percentage === "N/A" ? "red" : "green" }}>
              {tiktokAds.percentage}
            </Typography>
          </Card>
        </Grid>
      </Grid>

       <Typography variant="h6" fontWeight={800} gutterBottom>
        Google Ads
      </Typography>

      <Grid container spacing={2}>
       
        <Grid item size={{md:6}} sx={{mb:2}}>

            <Grid container spacing={2}>
              
              <Grid item size={{md:4}}>
                <Card sx={{ px: 1, py: 2, minHeight:95, textAlign: "center", position: "relative" }}>
                  <Typography variant="h4" sx={{ fontWeight: "bold", color: "#0718AB" }}>0</Typography>
                  <Typography sx={{ fontSize: "12px" }}>RESERVERINGEN</Typography>
                  <Typography sx={{ fontSize: "12px" }}>N/A</Typography>
                </Card>
              </Grid>
              <Grid item size={{md:4}}>
                <Card sx={{ px: 1, py: 2, minHeight:95, textAlign: "center", position: "relative" }}>
                  <Typography variant="h4" sx={{ fontWeight: "bold", color: "#0718AB" }}>0</Typography>
                  <Typography sx={{ fontSize: "12px" }}>CLICK CONTACTOPTIE</Typography>
                  <Typography sx={{ fontSize: "12px" }}>N/A</Typography>
                </Card>
              </Grid>
              <Grid item size={{md:4}}>
                <Card sx={{ px: 1, py: 2, minHeight:95, textAlign: "center", position: "relative" }}>
                  <Typography variant="h4" sx={{ fontWeight: "bold", color: "#0718AB" }}>0</Typography>
                  <Typography sx={{ fontSize: "12px" }}>CLICK DELIVERY/TAKEAWA</Typography>
                  <Typography sx={{ fontSize: "12px" }}>N/A</Typography>
                </Card>
              </Grid>
              <Grid item size={{md:4}}>
                <Card sx={{ px: 1, py: 2, minHeight:95, textAlign: "center", position: "relative" }}>
                  <Typography variant="h4" sx={{ fontWeight: "bold", color: "#0718AB" }}>0</Typography>
                  <Typography sx={{ fontSize: "12px" }}>KOSTEN PER RESERVERING</Typography>
                  <Typography sx={{ fontSize: "12px" }}>N/A</Typography>
                </Card>
              </Grid>
              <Grid item size={{md:4}}>
                <Card sx={{ px: 1, py: 2, minHeight:95, textAlign: "center", position: "relative" }}>
                  <Typography variant="h4" sx={{ fontWeight: "bold", color: "#0718AB" }}>0</Typography>
                  <Typography sx={{ fontSize: "12px" }}>VIEW MENU</Typography>
                  <Typography sx={{ fontSize: "12px" }}>N/A</Typography>
                </Card>
              </Grid>
              <Grid item size={{md:4}}>
                <Card sx={{ px: 1, py: 2, minHeight:95, textAlign: "center", position: "relative" }}>
                  <Typography variant="h4" sx={{ fontWeight: "bold", color: "#0718AB" }}>0</Typography>
                  <Typography sx={{ fontSize: "12px" }}>CLICK RESERVEER</Typography>
                  <Typography sx={{ fontSize: "12px" }}>N/A</Typography>
                </Card>
              </Grid>
            
            </Grid>

        </Grid>
        <Grid item size={{md:6}} sx={{mb:2}}>
          <Card sx={{ px: 0, py: 0, minHeight:230, textAlign: "center", position: "relative" }}>
            <CardContent>
              
              <Chart
                chartType="LineChart"
                width="100%"
                height="230px"
                data={data}
                options={options}
              />

            </CardContent>
          </Card>
        </Grid>
      </Grid>







      <Typography variant="h6" fontWeight={800} gutterBottom>
        Facebook / Meta
      </Typography>

      <Grid container spacing={2} sx={{mb:2}}>

        {/* Reach */}
        <Grid item size={{md:4}}>
          <Card sx={{ px: 3, py:2, textAlign: "center", position: "relative" }}>
            {metaScore_loading && (
              <CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />
            )}
            <Typography variant="h4" sx={{ fontWeight: "bold", color: "#0718AB" }}>
              {reach.views}
            </Typography>
            <Typography sx={{ fontSize: "12px" }}>MENSEN BEREIKT</Typography>
            <Typography sx={{ fontSize: "12px", color: reach.percentage === "N/A" ? "red" : "green" }}>
              {reach.percentage}
            </Typography>

            <Box sx={{ mt: 2, position: "relative" }}>
              
              <Box sx={{ overflowX: "auto" }}>
                <table style={{ width: "100%", fontSize: "12px" }}>
                  <thead>
                    <tr>
                      <th style={{ textAlign: "left" }}>Ad Name</th>
                      <th style={{ textAlign: "right" }}>Reach</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fbTable.map((row, i) => (
                      <tr key={i}>
                        <td style={{ textAlign: "left", borderTop:'1px solid #dddddd', padding:'5px' }}>
                          {row.ad_name?.split(" - ")[1]}
                        </td>
                        <td style={{ textAlign: "right", borderTop:'1px solid #dddddd', padding:'5px' }}>
                          {row.reach}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Box>
              {loadingTable && (<CircularProgress size={15} sx={{textAlign:'center'}} />)}
            </Box>


          </Card>
        </Grid>
        <Grid item size={{md:8}}>
          <Grid container spacing={2} sx={{mb:2}}>        
        
            <Grid item size={{md:4}}>
              <Card sx={{ px: 3, py:2, textAlign: "center", position: "relative" }}>
                {metaScore_loading && (
                  <CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />
                )}
                <Typography variant="h4" sx={{ fontWeight: "bold", color: "#0718AB" }}>
                  {spend.views}
                </Typography>
                <Typography sx={{ fontSize: "12px" }}>COST</Typography>
                <Typography sx={{ fontSize: "12px", color: spend.percentage === "N/A" ? "red" : "green" }}>
                  {spend.percentage}
                </Typography>
              </Card>
            </Grid>
            <Grid item size={{md:4}}>
              <Card sx={{ px: 3, py:2, textAlign: "center", position: "relative" }}>
                {metaScore_loading && (
                  <CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />
                )}
                <Typography variant="h4" sx={{ fontWeight: "bold", color: "#0718AB" }}>
                  {impressions.views}
                </Typography>
                <Typography sx={{ fontSize: "12px" }}>IMPRESSIONS</Typography>
                <Typography sx={{ fontSize: "12px", color: impressions.percentage === "N/A" ? "red" : "green" }}>
                  {impressions.percentage}
                </Typography>
              </Card>
            </Grid>
            <Grid item size={{md:4}}>
              <Card sx={{ px: 3, py:2, textAlign: "center", position: "relative" }}>
                {metaScore_loading && (
                  <CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />
                )}
                <Typography variant="h4" sx={{ fontWeight: "bold", color: "#0718AB" }}>
                  {cpm.views}
                </Typography>
                <Typography sx={{ fontSize: "12px" }}>CPM</Typography>
                <Typography sx={{ fontSize: "12px", color: cpm.percentage === "N/A" ? "red" : "green" }}>
                  {cpm.percentage}
                </Typography>
              </Card>
            </Grid>
          </Grid>

          <Card sx={{ p: 2, position: "relative", mb:2 }}>
            {loadingPie && <CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />}
            <Typography sx={{ fontSize: "12px", mb:2 }}>Bereik / Platform</Typography>
            {pieData.length > 1 && (
              <Chart
                chartType="PieChart"
                width="100%"
                height="300px"
                data={pieData}
              />
            )}
          </Card>

          <Card sx={{ p: 2, position: "relative" }}>
              {loadingFbInsta && <CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />}
              <Typography sx={{ fontSize: "12px", mb:2 }}>Facebook / Instagram</Typography>
              <table style={{ width: "100%", fontSize: "12px", textAlign:"left" }}>
                <thead>
                  <tr>
                    <th>Platform</th>
                    <th>Clicks</th>
                    <th>Spend</th>
                    <th>Impressions</th>
                    <th>CTR</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(fbInsta).map((platform, i) => (
                    <tr key={i}>
                      <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{platform}</td>
                      <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{fbInsta[platform]?.clicks}</td>
                      <td style={{borderTop:'1px solid #dddddd', padding:'5px'}} dangerouslySetInnerHTML={{ __html: fbInsta[platform]?.spend }} />
                      <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{fbInsta[platform]?.impressions}</td>
                      <td style={{borderTop:'1px solid #dddddd', padding:'5px'}} dangerouslySetInnerHTML={{ __html: fbInsta[platform]?.spend }} />
                    </tr>
                  ))}
                </tbody>
              </table>
            </Card>
          
        </Grid>
      </Grid>

        {/* PERFORMANCE / COMPAGNE */}

        <Card sx={{ p: 2, mb: 2, position: "relative" }}>
          {loadingCampaign && <CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />}
          <Typography sx={{ fontSize: "12px", mb:2 }}>PERFORMANCE / COMPAGNE</Typography>
          <table style={{ width: "100%", fontSize: "12px", textAlign:"left" }}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Clicks</th>
                <th>Spend</th>
                <th>Reach</th>
                <th>Impressions</th>
                <th>CPC</th>
              </tr>
            </thead>
            <tbody>
              {campaigns.map((row, i) => (
                <tr key={i}>
                  <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{row.campaign_name}</td>
                  <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{row.clicks}</td>
                  <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{row.spend}</td>
                  <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{row.reach}</td>
                  <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{row.impressions}</td>
                  <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{row.cpc}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>

        
        <Card sx={{ p: 2, position: "relative" }}>
          {loadingAdset && <CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />}
          <Typography sx={{ fontSize: "12px", mb:2 }}>PERFORMANCE / AD SET</Typography>
          <table style={{ width: "100%", fontSize: "12px", textAlign:"left" }}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Clicks</th>
                <th>Spend</th>
                <th>Reach</th>
                <th>Impressions</th>
                <th>CPC</th>
              </tr>
            </thead>
            <tbody>
              {adsets.map((row, i) => (
                <tr key={i}>
                  <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{row.adset_name}</td>
                  <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{row.clicks}</td>
                  <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{row.spend}</td>
                  <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{row.reach}</td>
                  <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{row.impressions}</td>
                  <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{row.cpc}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>


     
    </Box>
  );
}